import React from 'react';
import { STATUS } from '../../../constants';

export default ({status, readableStatus, handleGoBackClick, isDetails, report, response, user}) => {
  const _getStatusColor = () => {
    if (user.isInspector()) {
      if (report && report.status) {
        return report.status.toString().toLowerCase();
      }
    } else {
      if (report.status === STATUS.COMPLETE) {
        if (report.vresponseRequired) {
          if (response && response.status) {
            return response.status.toString().toLowerCase();
          }
        } else {
          if (report && report.status) {
            return report.status.toString().toLowerCase();
          }
        }
      } else {
        if (report && report.status) {
          return report.status.toString().toLowerCase();
        }
      }
    }

    return '';
  };

  return (
    <section className='scene__scene-header detailsScene__scene-header'>
      <div className='go-back-to-list-header-button' onClick={handleGoBackClick}>Back</div>
      <header className='_width_450'>
        Inspection Record Application
      </header>
      <div className={`detailsScene__status-label ${_getStatusColor()} _width_210`}>{readableStatus.toLowerCase()}</div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Edit/Header.jsx